
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.4 8.313c-.769 0-1.138.437-2.4.437s-1.629-.438-2.4-.438C1.612 8.313 0 9.96 0 11.989v.7C0 13.412.576 14 1.286 14h9.428c.71 0 1.286-.588 1.286-1.313v-.7c0-2.028-1.613-3.675-3.6-3.675zm2.314 4.374H1.286v-.7c0-1.301 1.039-2.362 2.314-2.362.391 0 1.026.438 2.4.438 1.385 0 2.006-.438 2.4-.438 1.275 0 2.314 1.06 2.314 2.363v.7zM6 7.875c2.13 0 3.857-1.764 3.857-3.938C9.857 1.764 8.13 0 6 0 3.87 0 2.143 1.764 2.143 3.938 2.143 6.11 3.87 7.874 6 7.874zm0-6.563c1.417 0 2.571 1.179 2.571 2.625 0 1.447-1.154 2.626-2.571 2.626-1.417 0-2.571-1.179-2.571-2.625C3.429 2.49 4.583 1.312 6 1.312z","fill":"#fff"}})])
          )
        }
      }
    